export const NUMBER_OF_VISIBLE_BET_OPTIONS = 5
export const MIDDLE_OF_VISIBLE_BET_OPTIONS = Math.floor(NUMBER_OF_VISIBLE_BET_OPTIONS / 2)
export const MAX_OFFSET_OF_VISIBLE_BET_OPTIONS = Math.ceil(NUMBER_OF_VISIBLE_BET_OPTIONS / 2)
